import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';


const VRFForm = ({ unit, onChange, onCopy, onDelete }) => {
  const handleChange = (key, value) => {
    const updatedUnit = { ...unit, [key]: value };
    onChange(updatedUnit);
  };

  const fieldStyle = { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 };
  const labelStyle = { width: 120, fontWeight: 'bold' };
  const inputStyle = {
    flex: 1,
    padding: '8px 10px',
    borderRadius: 6,
    border: '1px solid #ccc',
    fontSize: '15px',
    height: 38,
    lineHeight: '1.2',
    boxSizing: 'border-box',
  };

  const getImageSrc = () => {
    if (!unit.deviceGroup) return null;
    if (unit.deviceGroup === 'dis') return '/images/VRF_VRV/vrf.png';
    if (!unit.deviceModel) return null;

    const map = {
      tek_yon_kaset: 'tek_yon_kaset.png',
      '2_yon_kaset': '2_yon_kaset.png',
      '4_yon_kaset': '4_yon_kaset.png',
      '360_kaset': '360_kaset.png',
      dusuk_statik: 'lsp_kanalli.png',
      orta_statik: 'msp_kanalli.png',
      yuksek_statik: 'hsp_kanalli.png',
      duvar_tipi: 'duvar_tipi.png',
      yer_tavan: 'yer_tavan_tipi.png',
      konsol_tipi: 'konsol_tipi.png',
      doseme_tipi: 'doseme_tipi.png',
    };

    return `/images/VRF_VRV/${map[unit.deviceModel] || ''}`;
  };

  const imageSrc = getImageSrc();
  const imageAlt = unit.deviceGroup === 'dis'
    ? 'Dış Ünite Görseli'
    : unit.deviceModel
      ? 'İç Ünite Görseli'
      : '';

  return (
    <motion.div

    
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      style={{
        border: '1px solid #ccc',
        borderRadius: 10,
        padding: 20,
        backgroundColor: '#fff',
        boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
      }}
    >
      {/* Görsel */}
      <div style={{ textAlign: 'center', marginBottom: 10, minHeight: 155 }}>
        {imageSrc ? (
          <img
            src={imageSrc}
            alt={imageAlt}
            style={{ maxWidth: '100%', height: 175, objectFit: 'contain' }}
          />
        ) : (
          <p style={{ color: '#888', fontStyle: 'italic' }}>
            {!unit.deviceGroup ? 'Ürün Grubu Seçiniz' : 'Ürün Modeli Seçiniz'}
          </p>
        )}
      </div>

      {/* Başlık */}
      <h3 style={{ textAlign: 'center', marginBottom: 20 }}>
        {unit.unitName}{' '}
        <span style={{ fontWeight: 'normal', fontSize: '0.9rem' }}>
          x {unit.quantity || 1} adet
        </span>
      </h3>

      {/* Ürün Grubu */}
      <div style={fieldStyle}>
        <label style={labelStyle}>Ürün Grubu:</label>
        <select
          value={unit.deviceGroup || ''}
         onChange={(e) => {
  const value = e.target.value;
  const updatedUnit = {
    ...unit,
    deviceGroup: value,
    deviceModel: '', // her grup değiştiğinde model sıfırlanır
  };
  onChange(updatedUnit);
}}

          style={inputStyle}
        >
          <option value="">Seçiniz</option>
          <option value="dis">Dış Ünite</option>
          <option value="ic">İç Ünite</option>
        </select>
      </div>

    <AnimatePresence>
  {unit.deviceGroup && (
    <>
      {/* Ürün Modeli */}
      <motion.div
        key="model"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        transition={{ duration: 0.3 }}
        style={fieldStyle}
      >
        <label style={labelStyle}>Ürün Modeli:</label>
        <select
          value={unit.deviceModel || ''}
          onChange={(e) => handleChange('deviceModel', e.target.value)}
          style={inputStyle}
        >
          <option value="">Seçiniz</option>
          {unit.deviceGroup === 'dis' ? (
            <>
              <option value="2_borulu">2 Borulu</option>
              <option value="3_borulu">3 Borulu (Heat-Recovery)</option>
            </>
          ) : (
            <>
              <option value="tek_yon_kaset">Tek Yön Kaset</option>
              <option value="2_yon_kaset">2 Yön Kaset</option>
              <option value="4_yon_kaset">4 Yön Kaset</option>
              <option value="360_kaset">360 Kaset</option>
              <option value="dusuk_statik">Düşük Statik Basınç Kanallı</option>
              <option value="orta_statik">Orta Statik Basınç Kanallı</option>
              <option value="yuksek_statik">Yüksek Statik Basınç Kanallı</option>
              <option value="duvar_tipi">Duvar Tipi</option>
              <option value="yer_tavan">Yer-Tavan Tipi</option>
              <option value="konsol_tipi">Konsol Tipi</option>
              <option value="doseme_tipi">Döşeme Tipi</option>
            </>
          )}
        </select>
      </motion.div>

      {/* Kapasite */}
      {unit.deviceModel && (
        <motion.div
          key="capacity"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.3 }}
          style={fieldStyle}
        >
          <label style={labelStyle}>Kapasite:</label>
          <select
            value={unit.capacity || ''}
            onChange={(e) => handleChange('capacity', e.target.value)}
            style={inputStyle}
          >
            <option value="">Seçiniz</option>
            {unit.deviceGroup === 'dis'
              ? Array.from({ length: 14 }, (_, i) => {
                  const hp = (i + 2) * 2;
                  return (
                    <option key={hp} value={`${hp} HP`}>
                      {`${hp} HP`}
                    </option>
                  );
                })
              : [
                  '2,2 kW', '2,8 kW', '3,6 kW', '4,5 kW', '5,6 kW',
                  '6 kW', '7,1 kW', '9 kW', '11,2 kW', '12,8 kW',
                  '14 kW', '18 kW', '22,4 kW', '28 kW',
                ].map((kw) => (
                  <option key={kw} value={kw}>
                    {kw}
                  </option>
                ))}
            <option value="diğer">Diğer</option>
          </select>
        </motion.div>
      )}

      {/* Diğer seçildiğinde özel kapasite alanı */}
      {unit.deviceModel && unit.capacity === 'diğer' && (
        <motion.div
          key="customCapacity"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.3 }}
          style={fieldStyle}
        >
          <label style={labelStyle}>Kapasite Belirt:</label>
          <input
            type="text"
            value={unit.customCapacity || ''}
            onChange={(e) => handleChange('customCapacity', e.target.value)}
            placeholder="Kapasite Belirtiniz"
            style={inputStyle}
          />
        </motion.div>
      )}
    </>
  )}
</AnimatePresence>

      {/* Adet */}
      <div style={fieldStyle}>
        <label style={labelStyle}>Adet:</label>
        <input
          type="number"
          min="1"
          value={unit.quantity || 1}
          onChange={(e) => handleChange('quantity', e.target.value)}
          placeholder="Örn: 2"
          style={inputStyle}
        />
      </div>

      {/* Butonlar */}
      <div
        style={{ display: 'flex', justifyContent: 'space-between', marginTop: 15 }}
      >
        <button
          onClick={onCopy}
          style={{
            backgroundColor: '#6366f1',
            color: 'white',
            padding: '6px 12px',
            borderRadius: 6,
          }}
        >
          Kopyala
        </button>
        <button
          onClick={onDelete}
          style={{
            backgroundColor: '#d9534f',
            color: 'white',
            padding: '6px 12px',
            borderRadius: 6,
          }}
        >
          Sil
        </button>
      </div>
    </motion.div>
  );
};

export default VRFForm;
